import { render, staticRenderFns } from "./layerRadioGroupBlock.vue?vue&type=template&id=3b4d2fcd&scoped=true&"
import script from "./layerRadioGroupBlock.vue?vue&type=script&lang=js&"
export * from "./layerRadioGroupBlock.vue?vue&type=script&lang=js&"
import style0 from "./layerRadioGroupBlock.vue?vue&type=style&index=0&id=3b4d2fcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b4d2fcd",
  null
  
)

export default component.exports